import React from 'react';
import { BarChart3Icon, CalendarDaysIcon, ChevronDownIcon, ClipboardListIcon, DollarSignIcon, LayoutDashboardIcon, ListIcon, MessagesSquareIcon, NetworkIcon, TagIcon, TrophyIcon, UsersIcon } from 'lucide-react';
import { connectSidebar } from '../../data/connect';
import { ProgramDrawer } from './ProgramDrawer';
const icons: Record<string, typeof ListIcon> = {
  dashboard: LayoutDashboardIcon,
  insights: BarChart3Icon,
  finance: DollarSignIcon,
  training: CalendarDaysIcon,
  members: UsersIcon,
  league: NetworkIcon,
  discounts: TagIcon,
  support: ClipboardListIcon,
  comms: MessagesSquareIcon,
  programsNew: TrophyIcon,
  programs: TrophyIcon,
  roster: ListIcon
};
export function ConnectShell() {
  return <div className="relative h-full w-full overflow-hidden bg-connect-canvas font-connect" data-id="element-25" data-mp="1oibblu02fejm">
      <aside className="absolute inset-y-0 left-0 w-[250px] border-r border-connect-line bg-white py-4" aria-hidden="true" data-id="element-26" data-mp="2c8p6dsa1brhw">
        <ul className="space-y-0.5" data-id="element-27" data-mp="19fxvz2fz0rti">
          {connectSidebar.map(item => {
          const Icon = icons[item.id];
          return <li key={item.id} className={`flex items-center gap-3 py-2.5 text-[15px] ${item.indent ? 'pl-10' : 'pl-5'} ${item.active ? 'bg-red-50 text-connect-newRed' : 'text-connect-ink'}`} data-id="element-28" data-mp="14i64uan5h9qd">
                <Icon className="h-4 w-4 text-connect-muted" data-id="element-29" data-mp="1s5wbg3m3ln76" />
                {item.isNew && <span className="rounded-full bg-connect-blueSoft px-1.5 text-[10px] font-bold text-connect-blueDark" data-id="element-30" data-mp="1o4ua9h8mf12k">NEW</span>}
                <span className={item.isNew ? 'text-connect-newRed' : ''} data-id="element-31" data-mp="224vaqvkz46hi">{item.label}</span>
                {(item.id === 'members' || item.id === 'league') && <ChevronDownIcon className="ml-auto mr-4 h-4 w-4 text-connect-muted" data-id="element-32" data-mp="1x3fqh5qme406" />}
              </li>;
        })}
        </ul>
      </aside>
      <div className="absolute inset-y-0 left-[250px] right-0" aria-hidden="true" data-id="element-33" data-mp="2sj6qda2px5j">
        <div className="flex h-14 items-center bg-connect-blue px-6 text-white" data-id="element-34" data-mp="22ua9k98t611s">
          <span className="text-lg font-black italic tracking-tight" data-id="element-35" data-mp="27stvwarbdeuo">i9 SPORTS</span>
          <span className="ml-4 text-xl" data-id="element-36" data-mp="27uokq05phr41">Programs</span>
        </div>
        <div className="space-y-3 p-6" data-id="element-37" data-mp="2bsvsi5i6zi33">
          {[0, 1, 2, 3].map(i => <div key={i} className="h-16 rounded-md bg-white" data-id="element-38" data-mp="2gul1lflutloj" />)}
        </div>
      </div>
      <div className="absolute inset-0 bg-black/45" aria-hidden="true" data-id="element-39" data-mp="2lrjz884q8arh" />
      <ProgramDrawer data-id="element-40" data-mp="2qr69c8p9daw2" />
    </div>;
}